<script lang="ts">
  interface Props {
    size?: number;
    [key: string]: any;
  }

  let { size = 16, ...rest }: Props = $props();
</script>

<svg
  width={size}
  height={size}
  viewBox="0 0 17 17"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
  {...rest}
>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M13.5303 4.53033C13.8232 4.23744 13.8232 3.76256 13.5303 3.46967C13.2374 3.17678 12.7626 3.17678 12.4697 3.46967L8.5 7.43934L4.53033 3.46967C4.23744 3.17678 3.76256 3.17678 3.46967 3.46967C3.17678 3.76256 3.17678 4.23744 3.46967 4.53033L7.43934 8.5L3.46967 12.4697C3.17678 12.7626 3.17678 13.2374 3.46967 13.5303C3.76256 13.8232 4.23744 13.8232 4.53033 13.5303L8.5 9.56066L12.4697 13.5303C12.7626 13.8232 13.2374 13.8232 13.5303 13.5303C13.8232 13.2374 13.8232 12.7626 13.5303 12.4697L9.56066 8.5L13.5303 4.53033Z"
    fill="currentColor"
  />
</svg>
